import React from "react";
import "./style.css";
import Hero from "./Hero";
import Header from "./Header";
import About from "./About";
import MySkills from "./MySkills";
import Experienc from "./Experienc";
import MyWorks from "./MyWorks";
import Contact from "./Contact";
import Footer from "./Footer";
import MobileHeader from "./MobileHeader";
const Home = () => {
  return (
    <>
      <Header />
      <MobileHeader />
      <Hero />
      <About />
      <MySkills />
      <Experienc />
      <MyWorks />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
